import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { BadgesAwardsService } from '../../../core/services/badges-awards/badges-awards.service';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { StripePaymentService } from 'src/app/core/services/stripe-payment.service';
import { UserDetailsService } from 'src/app/core/services/user-details/user-details.service';

@Component({
  selector: 'app-badges-awards',
  templateUrl: './badges-awards.component.html',
  styleUrls: ['./badges-awards.component.css']
})
export class BadgesAwardsComponent implements OnInit {
  @ViewChild('dialogTemplate') dialogTemplate: TemplateRef<any>;
  @ViewChild('ecodialogTemplate') ecodialogTemplate: TemplateRef<any>;

  constructor(private service: BadgesAwardsService, private dialog: MatDialog, private router: Router,
    private spinner: NgxSpinnerService, private stripePayment: StripePaymentService,
    private userService: UserDetailsService
  ) { }

  allBadges: any = [];
  statusBadges: any = [];
  ecoBadges: any ;
  showEcoBadges: any = [];
  currency: any;
  disable = false;
  isFirstItemEarned: boolean = false;
  badgeAmounts: number[] = [];
  availableCurrency: any;
  badgeCost: any;
  remainingAmount: any;
  amountDeducted: any;
  finalAmount: any = [];
  badgeId: any;
  paymentType: string = "payment_by_currency";
  paymentDone: boolean = false;
  amount: any;
  productType: any;
  closePopup: any;
  visibleEcoBadges: any[] = [];
  showMoreButton: boolean = true;
  showLessButtonVisible: boolean = false;
  batchSize: number = 15;
  status: boolean = false;
  handler: any = null;
  badge: any;
  images: any = [];
  userDetials: any;
  userId: any;
  isUserLogin = false;
  dialogRef: any;
  creaticsBadgesList: any;
  ecoBadgepopup = false;
  earnedStripeBadges: any = [];
  badgeurl: any;
  badgename: any;
  stripeAmount: any;
  maxItems:any = 15;
  ngOnInit(): void {
    this.service.getCreaticsCurrency().subscribe((curr: any) => {
      this.currency = curr.userCreaticsCurrency;
      this.service.getBadges().subscribe((res: any) => {
        this.allBadges = res.previousBadges.reverse();
        // this.earnedStripeBadges.push(...this.allBadges);
        this.statusBadges = res.statusBadges;
        this.ecoBadges = res.ecoSystemBadges;

        this.filterEcoBadges();
        this.calculateBadgeAmounts();

        this.showEcoBadges = this.ecoBadges.slice(0, this.batchSize);
        this.showMoreButton = this.showEcoBadges.length < this.ecoBadges.length;
        this.showLessButtonVisible = false;
      });
    });

    this.userService.getShowcases().subscribe((res) => {
      this.userId = res.user;
      if (res.user > 0) {
        this.isUserLogin = true;
        this.userService.getUserDetails(res.user).subscribe((resp) => {
          this.userDetials = resp;
        });
      } else {
        this.isUserLogin = false;
      }
    });
  }

  getEarnedBadgeIds(): number[] {
    return this.earnedStripeBadges
      .filter(badge => badge.id !== undefined) // Ensure badge.id exists
      .map(badge => badge.id); // Extract the badge.id
  }

  filterEcoBadges(): void {
    const earnedBadgeIds = this.getEarnedBadgeIds();

    this.showEcoBadges = this.ecoBadges.filter(badge => !earnedBadgeIds.includes(badge.id));
  }

  showMore() {
   this.showEcoBadges = this.ecoBadges
      this.showMoreButton = false;
      this.showLessButtonVisible = true;
    
  }

  showLess() {
    this.showEcoBadges = this.ecoBadges.slice(0, this.batchSize);
    this.showMoreButton = true;
    this.showLessButtonVisible = false;
  }

  calculateBadgeAmounts() {
    this.statusBadges.forEach((item: any) => {
      const amount: number = item.badgeamount;
      this.badgeAmounts.push(amount);
    });
    this.calculateCurrency();
  }

  calculateCurrency() {
    if (this.currency && this.statusBadges) {
      this.availableCurrency = this.currency;
      this.remainingAmount = [];
      this.statusBadges.forEach((item: any) => {
        const remainingForBadge = Math.max(item.badgeamount - this.availableCurrency, 0);
        this.remainingAmount.push(remainingForBadge);
        this.badgeId = item.badgeid;
      });
    }
  }

  creaticsCurrency(badgeId, amount, id, name) {
    localStorage.setItem('paymentRedirect', 'true');
    const requestBody = { id: id, name: name };
    this.spinner.show();
    this.service.getCurrency(badgeId, 0, "payment_by_currency", "Badges", amount)
      .subscribe((res: any) => {
        this.service.setRequestBody(requestBody);
        this.spinner.hide();
        this.router.navigate(['/charge/products/' + badgeId]);
      },
        (err) => {
          this.spinner.hide();
          alert('Error! Payment Failed')
          window.location.reload();
        }
      )
  }

  creaticsCurrencyEco(badgeId, totalAmt, id, name) {
    localStorage.setItem('paymentRedirect', 'true');
    const requestBody = { id: id, name: name };
    this.spinner.show();
    this.service.getCurrency(badgeId, 0, "payment_by_currency", "Badges", totalAmt)
      .subscribe((res: any) => {
        this.service.setRequestBody(requestBody);
        this.router.navigate(['/charge/products/' + badgeId]);
        this.spinner.hide();
      },
        (err) => {
          this.spinner.hide();
          alert('Error! Payment Failed')
          window.location.reload();
        })
  }

  stripeHandle(id: any) {
    this.service.getBadgeDetailsById(id).subscribe((res: any) => {
      this.stripeAmount = res.stripeAmount;
    })
  }

  paymentHandler(badgeId, amount, id, name, url) {
    this.spinner.show();
    this.stripePayment.openCheckout(name, this.stripeAmount, " ", url, this.userDetials.emailAddress, (tokenId: any) => {
      this.onTokenReceived(tokenId, name, amount, url, id, badgeId);
    });
  }

  onTokenReceived(tokenId: any, name: any, amount: any, url: any, id: any, badgeId: any) {
    this.service.createPayment(tokenId, amount * 100, badgeId)
      .subscribe((res: any) => {
        alert("Payment successful!!");
        this.closeModal();
        this.spinner.hide();
        localStorage.setItem('paymentRedirect', 'true');
        localStorage.setItem('stripePayment', 'true');
        this.router.navigate(['charge/products/' + badgeId]);
      }, (err) => {
        this.spinner.hide();
        alert('Error! Payment Failed');
        window.location.reload();
      });
  }

  closeModal() {
    this.dialogRef.close();
  }

  openDialog(badge: any, i: number) {
    console.log('first item',this.isFirstItemEarned)
    if (i > 0 && !this.isFirstItemEarned) {
      alert('Hi!\nYou need to earn the available badge to unlock this badge!\nBadge Amount:' +badge.badgeamount+ " Creatics Currency");
    }
    else{
      const remainingCurrency = badge.badgeamount - this.availableCurrency;

      if (this.availableCurrency >= badge.badgeamount) {
        this.disable = true;
      }
      const dialogRef = this.dialog.open(this.dialogTemplate, {
        data: {
          image: badge.badgeurl,
          amount: badge.badgeamount,
          remainingCurrency: remainingCurrency > 0 ? remainingCurrency : 0,
          name: badge.badgename,
          badgeId: badge.badgeid,
          id: badge.id
        }
      });
    }
    
  }

  openDialogEco(ecobadge: any) {
    this.stripeHandle(ecobadge.id);
    if (this.availableCurrency >= ecobadge.badgeamount) {
      this.ecoBadgepopup = true;
    }
    else{
      this.ecoBadgepopup = false;
    }
    this.dialogRef = this.dialog.open(this.ecodialogTemplate, {
      data: {
        name: ecobadge.badgename,
        image: ecobadge.badgeurl,
        totalAmt: ecobadge.badgeamount,
        badgeId: ecobadge.badgeid,
        id: ecobadge.id
      }
    });
    this.dialogRef.afterClosed().subscribe(result => {
    });
  }
}